@if (required) {
  <div class="weaveFormField">
    @if (label && longTitle) {
      <div class="pageHeader" id="{{id}}">
        {{label}}<span class="required">*</span>
      </div>
    }
    <mat-form-field
      appearance="{{appearance}}"
      [class]="['fullWidth']"
      [hideRequiredMarker]="hideRequiredMarker"
    >
      @if (label && !longTitle) { <mat-label>{{label}}</mat-label> }
      <input
        matInput
        [class]="['weaveInput']"
        [type]="type"
        [disabled]="disabledFlag"
        (keyup.enter)="onFocusOut(); onKeyUpEnter();"
        (focusout)="onFocusOut()"
        (paste)="onPaste($event)"
        (keyup)="onKeyUp($event)"
        (keydown)="onKeyDown($event)"
        [(ngModel)]="data"
        (focusin)="startEdit()"
        (keydown.escape)="undo()"
        [placeholder]="placeholder"
        [maxlength]="maxlength"
        [email]="type === 'email'"
        [appRequireTld]="type === 'email'"
        required
        #ctrl="ngModel"
        #inputElement
      >
      @if(ctrl.invalid && ctrl.touched) {

        <mat-error>
          @if (ctrl.hasError('email') || ctrl.hasError('missingTld')) {
            Invalid email
          }
          @else if (ctrl.hasError('required')) {
            {{label || "This field"}} is required
          }
        </mat-error>
      }
      @if (showError && data === '' && required) {
        <div
          class="weaveFormField_error">
          {{label || "This field"}} cannot be empty
        </div>
      }
    </mat-form-field>
    @if (description) {
      <div class="applicationHTML" [innerHTML]="description"></div>
    }
  </div>
}
@if (!required) {
  <div class="weaveFormField">
    @if (label && longTitle) {
      <div class="pageHeader" id="{{id}}">
        {{label}}
      </div>
    }
    <mat-form-field appearance="outline" class="fullWidth">
      @if (label && !longTitle) { <mat-label>{{label}}</mat-label> }
      <input
        matInput
        class='weaveInput'
        [type]="type"
        [disabled]="disabledFlag"
        (keyup.enter)="onFocusOut(); onKeyUpEnter();"
        (keydown)="onKeyDown($event)"
        (paste)="onPaste($event)"
        (focusout)="onFocusOut()"
        (keyup)="onKeyUp($event)"
        [(ngModel)]='data'
        (focusin)="startEdit()"
        (keydown.escape)="undo()"
        [placeholder]="placeholder"
        [maxlength]="maxlength"
        #inputElement
      >
    </mat-form-field>
    @if (description) {
      <div class="applicationHTML" [innerHTML]="description"></div>
    }
  </div>
  }
